module.exports = __webpack_public_path__ + "static/media/WAHAROA TITLE.b41917d9.jpg";